import http from '../../http/http';
const HOST_URL = 'https://rails.makemytrip.com';

const ROUTES_URL = `${HOST_URL}/pwa/mobile/enquiry/breakJourney/routes`;
export const getBreakJourneyRoutesApi = (params: any) => http.post(ROUTES_URL, params);

const FAIR_AND_AVAIL_URL = `${HOST_URL}/pwa/mobile/enquiry/breakJourney/save`;
export const getBreakJourneyFareAndAvailApi = (params: any) =>  http.post(FAIR_AND_AVAIL_URL, params);

const PENDING_LEG_DETAILS_URL = `${HOST_URL}/pwa/mobile/search/breakJourney/pendingLeg/details`;
export const getPendingLegDetailsApi = (params: any) => http.post(PENDING_LEG_DETAILS_URL, params);

const DISCLAIMER_TEXT_URL = `${HOST_URL}/pwa/mobile/enquiry/breakJourney/texts`;
export const getDisclamerApi = () => http.get(DISCLAIMER_TEXT_URL);
